<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/user']"><img src="assets/images/admin/backarrow.png" /> Back to User Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png"/> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="userDetail" *ngIf="userDetail">
                    <h2>{{userDetail.first_name}} {{userDetail.last_name}}<small>Created on {{userDetail.created_dttm |  date:'d MMM, y'}}</small></h2>
                    <!-- <h3>Central Railway Zone</h3> -->
                    <h3>{{userDetail.organisation_name}}</h3> 
                    <!-- organization name visibale Milan -->
                    <div class="userDetailSocial">
                        <a href="mailto:userDetail.email"><b><img src="assets/images/admin/mail.png" /></b>{{userDetail.email}}</a>
                        <a href="tel:+userDetail.phone"><b><img src="assets/images/admin/phone.svg" /></b>{{userDetail.phone}}</a>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <ul class="customTab">
                    <li><a href="javascript:void(0);" [routerLink]="['/view_courses']" [queryParams]="{user_id:userID}">VIEW COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/assign_courses']" [queryParams]="{user_id:userID}">ASSIGN COURSES</a> </li>
                    <li><a href="javascript:void(0);" [routerLink]="['/user_edit']" [queryParams]="{id:userID,type:'edit'}" class="active">EDIT</a> </li>
                    <li *ngIf="userDetail?.is_active==1"  class="deactiveTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']" [queryParams]="{user_id:userID}">DEACTIVATE</a> </li>
                    <li *ngIf="userDetail?.is_active==0"  class="deactiveTab"><a href="javascript:void(0);" [routerLink]="['/user_deactive']" [queryParams]="{user_id:userID}">ACTIVATE</a> </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="formHeading">
        <h2>Edit</h2>
        <p>Edit the user’s details</p>
    </div>
    <form [formGroup]="userForm">
    <div class="formArea pl-5 pr-5">
        <div class="col-12 col-md-3">
            <div class="uploadImageWrap">
                <figure *ngIf="imageSrc =='' || imageSrc ==null">
                    <img src="assets/images/admin/placeholder.png" />
                </figure>
                <figure *ngIf="imageSrc !='' && imageSrc !=null ">
                    <img [src]="imageSrc" />
                </figure>
        
                <div class="uploadImage">
                    <span>Upload Picture</span>
                    <input type="file" (change)="onFileChange($event)" />
                    <div *ngIf="submitted && f.user_image.errors">
                        <span *ngIf="f.user_image.errors.required" class="text-mute text-danger errorText">This field
                            is required</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-9">
            <div class="row">

        <div class="col-12 col-md-6">
            <div class="commanInput">
                <mat-form-field class="example-full-width">
                    <mat-label>First Name</mat-label>
                    <input matInput formControlName="first_name" [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }" autocomplete="off">
                </mat-form-field> 
                <div *ngIf="submitted && f.first_name.errors">
                    <span *ngIf="f.first_name.errors.required" class="text-mute text-danger errorText">This field is required</span>
                    <span *ngIf="f.first_name.errors.pattern" class="text-mute text-danger errorText">Only alphabets are allowed</span>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <div class="commanInput">
                <mat-form-field class="example-full-width">
                    <mat-label>Last Name</mat-label>
                    <input matInput formControlName="last_name" [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }" autocomplete="off">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.last_name.errors">
                        <!-- <span *ngIf="f.last_name.errors.required" class="text-mute text-danger errorText">This field is required</span> -->
                        <span *ngIf="f.last_name.errors.pattern" class="text-mute text-danger errorText">Only alphabets are allowed</span>
                    </div>
                </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="commanInput">
            <mat-form-field class="example-full-width" >
                <mat-label>Email ID</mat-label>
                <input matInput formControlName="email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" autocomplete="off" [attr.disabled]="true">
                    </mat-form-field> 
                    <div *ngIf="submitted && f.email.errors">
                        <span *ngIf="f.email.errors.required" class="text-mute text-danger errorText">This field is required</span>
                        <span *ngIf="f.email.errors.pattern" class="text-mute text-danger errorText">email already exists</span>
                    </div>
            <span class="text-mute text-danger errorText" *ngIf="emailError=='Email already exist.'">{{emailError}}</span>      
        </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="commanInput">
        <mat-form-field class="example-full-width">
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phone" [ngClass]="{ 'is-invalid': submitted && f.phone.errors }"  numbersOnly maxlength = "10" autocomplete="off">
                </mat-form-field> 
                <div *ngIf="submitted && f.phone.errors">
                    <span *ngIf="f.phone.errors.required" class="text-mute text-danger errorText">This field is required</span>
                    <span *ngIf="f.phone.errors.pattern" class="text-mute text-danger errorText">Please input valid phone number</span>
                    <span *ngIf="f.phone.errors.minLength" class="text-mute text-danger errorText">Please enter mininmum 10 digit</span>
                    <span *ngIf="f.phone.errors.maxLength" class="text-mute text-danger errorText">Please enter maxmimum 10 digit</span>
                </div>
                <span class="text-mute text-danger errorText" *ngIf="phoneError =='Phone already exists.'">{{ phoneError}}</span>
                <span class="text-mute text-danger errorText" *ngIf="phoneError =='Please input valid phone number'">{{ phoneError}}</span>
    </div>
</div>

<div class="col-12 col-md-6">
    <div class="commanSelect singleSelect">
        <mat-form-field appearance="fill">
        <mat-label>Organization</mat-label>
        <!-- formControlName="organisation_id" [ngClass]="{ 'is-invalid': submitted && f.organisation_id.errors }" -->
        <mat-select formControlName="organisation_id" [ngClass]="{ 'is-invalid': submitted && f.organisation_id.errors }">
            <mat-option value="">None</mat-option>
            <mat-option *ngFor="let organisation of organisationData" [value]="organisation.organisation_id"  value="1">{{organisation.org_name}}</mat-option>
        </mat-select>
        </mat-form-field> 
        <div *ngIf="submitted && f.organisation_id.errors">
            <span *ngIf="f.organisation_id.errors.required" class="text-mute text-danger errorText">This field is required</span>
        </div>
    </div>
</div>
</div>
</div>
<div class="d-flex w-100 align-items-center justify-content-center">
    <a href="javascript:void(0);" class="backPage ml-2 mr-2"  [routerLink]="['/user']">Cancel</a>
    <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-2 mr-2" (click)="editUser(userForm.value)">Update Details</a>
</div>
    </div>
    <input type="hidden" (click)="open(update)" id="successMsg">
    </form>
    <!-- <a href="javascript:void(0);" (click)="open(update)" class="backPage ml-2 mr-2"> open model</a> -->
</div>
<!-- <ng-template #update let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>User Action Message</h6>
                <p class="size18">User updated sucessfully.</p>
                <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template> -->
<ng-template #update let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Edit User </h6>
                <p class="size18">User updated successfully.</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>
